import { action } from 'typesafe-actions';
import { IUpdateWalletTagsPayload, IWalletTags } from '@kattana-io/common';

const entity = 'wallet_tags';
const GET_WALLET_TAGS = `${entity}/UPDATE_WALLET_TAGS`;
const SET_WALLET_TAGS = `${entity}/SET_WALLET_TAGS`;
const CLEAR_WALLET_TAGS = `${entity}/RESET_WALLET_TAGS`;
const UPDATE_WALLET_TAGS = `${entity}/UPDATE_WALLET_TAGS`;
const UPDATE_WALLET_TAGS_SUCCESS = `${entity}/UPDATE_WALLET_TAGS_SUCCESS`;

const actionGetWalletTags = () => action(GET_WALLET_TAGS);
const actionSetWalletTags = (walletTags: IWalletTags) =>
  action(SET_WALLET_TAGS, walletTags);
const actionClearWalletTags = () => action(CLEAR_WALLET_TAGS);
const actionUpdateWalletTags = (payload: IUpdateWalletTagsPayload) =>
  action(UPDATE_WALLET_TAGS, payload);
const actionUpdateSuccessWalletTags = (payload: IUpdateWalletTagsPayload) =>
  action(UPDATE_WALLET_TAGS_SUCCESS, payload);

export {
  GET_WALLET_TAGS,
  SET_WALLET_TAGS,
  CLEAR_WALLET_TAGS,
  UPDATE_WALLET_TAGS,
  UPDATE_WALLET_TAGS_SUCCESS,
  actionGetWalletTags,
  actionSetWalletTags,
  actionClearWalletTags,
  actionUpdateWalletTags,
  actionUpdateSuccessWalletTags,
};
